export default "__VITE_ASSET__BwmPHlJN__"